import { ChatMessage, MessageData } from 'app/components/shared/Chat'
import { formatApiIsoDate } from 'app/utils/date'
import { QuotationRequestMessage } from 'EstraSuppliers'
import { v4 as uuidv4 } from 'uuid'

/* MAPPERS */

export const MapToChatMessageData = (
  quotationRequestMessage: QuotationRequestMessage
): MessageData => {
  return {
    username: quotationRequestMessage.username,
    isYou: quotationRequestMessage.sender_type === 'supplier',
    message: quotationRequestMessage.message,
    attachment_url: quotationRequestMessage.attachment_url,
    attachment_name: quotationRequestMessage.attachment_name,
    type: quotationRequestMessage.type,
    display_sent_at: formatApiIsoDate(
      quotationRequestMessage.sent_at,
      true,
      true,
      ' '
    ),
    sent_at: quotationRequestMessage.sent_at,
  }
}

export const MapToChatMessage = (
  quotationRequestMessage: QuotationRequestMessage
): ChatMessage => {
  return {
    data: MapToChatMessageData(quotationRequestMessage),
    id: uuidv4(),
  }
}
